import {
  Component, EventEmitter, OnDestroy, OnInit, Output,
} from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { AccessService } from '../../../services/AccessService';
import {
  DashboardNotification,
  NotificationService,
} from '../../../services/NotificationService';
import {
  ApplicationTheme, ThemeService,
} from '../../../services/ThemeService';

@Component({
  selector: 'app-navbar',
  standalone: false,
  templateUrl: './navbar.component.html',
  styleUrl: './navbar.component.sass',
})
export class NavbarComponent implements OnInit, OnDestroy {
  @Output()
  public readonly toggleSidebar = new EventEmitter<void>();

  public notificationsOpen = false;
  public profileOpen = false;
  public notifications: DashboardNotification[] = [];
  private notificationsSubscription: Subscription | null = null;

  public constructor(
    private themeService: ThemeService,
    private accessService: AccessService,
    private notificationService: NotificationService,
    private router: Router,
  ) { }

  public ngOnInit(): void {
    this.notificationsSubscription = this.notificationService.notifications$.subscribe((notifications) => {
      this.notifications = notifications;
    });
    void this.notificationService.refresh();
  }

  public ngOnDestroy(): void {
    this.notificationsSubscription?.unsubscribe();
  }

  public get theme(): ApplicationTheme {
    return this.themeService.getTheme();
  }

  public get themeTitle(): string {
    return this.theme === 'dark' ? 'Включить светлую тему' : 'Включить темную тему';
  }

  public get unreadNotificationsCount(): number {
    return this.notifications.filter((notification) => !notification.read).length;
  }

  public get recentNotifications(): DashboardNotification[] {
    return this.notifications.slice(0, 5);
  }

  public toggleTheme(): void {
    this.themeService.toggleTheme();
  }

  public toggleNotifications(): void {
    this.notificationsOpen = !this.notificationsOpen;
    this.profileOpen = false;
    if (this.notificationsOpen) {
      void this.notificationService.refresh();
    }
  }

  public toggleProfile(): void {
    this.profileOpen = !this.profileOpen;
    this.notificationsOpen = false;
  }

  public closeMenus(): void {
    this.notificationsOpen = false;
    this.profileOpen = false;
  }

  public clearNotifications(): void {
    this.notificationService.clear();
  }

  public markAllNotificationsAsRead(): void {
    this.notificationService.markAllAsRead();
  }

  public markNotificationAsRead(notification: DashboardNotification): void {
    if (!notification.read) {
      this.notificationService.markAsRead(notification.id);
    }
  }

  public async openNotificationsPage(): Promise<void> {
    this.notificationsOpen = false;
    await this.router.navigate(['/dashboard/notifications']);
  }

  public formatRelativeTime(value: string): string {
    const seconds = Math.max(Math.floor((Date.now() - new Date(value).getTime()) / 1000), 0);
    if (seconds < 60) {
      return 'сейчас';
    }

    const minutes = Math.floor(seconds / 60);
    if (minutes < 60) {
      return `${minutes.toString()} мин`;
    }

    const hours = Math.floor(minutes / 60);
    if (hours < 24) {
      return `${hours.toString()} ч`;
    }

    return new Intl.DateTimeFormat('ru-RU', {
      day: '2-digit',
      month: '2-digit',
    }).format(new Date(value));
  }

  public async logout(): Promise<void> {
    this.accessService.unauthorize();
    this.closeMenus();
    await this.router.navigate([
      'sign-in',
    ]);
  }
}
